import React, { useState } from 'react';
import { Box, Typography, Divider, Stack, Button } from '@mui/material';
import { colors } from '../constants/globalcss';
import { commonStyles } from '../styles/commonStyles';
import HelpModal from './HelpModal/HelpModal';

const SignupSection: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSignupClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box sx={commonStyles.sectionContainer}>
        <Stack spacing={3} alignItems="center" sx={commonStyles.contentStack}>
          <Typography variant="h4" sx={commonStyles.sectionTitle}>
            Need Help?
          </Typography>

          <Typography
            variant="body1"
            textAlign="center"
            sx={commonStyles.descriptionText}
          >
            Having trouble logging in or need to create a new account? We're
            here to help you get started.
          </Typography>

          <Divider sx={{ my: 1, width: '100%' }} />

          <Button
            variant="contained"
            color="primary"
            sx={commonStyles.secondaryButton}
            onClick={handleSignupClick}
          >
            Get Help
          </Button>
        </Stack>
      </Box>

      <HelpModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default SignupSection;
